/**
 * @file pictureタグのpolyfill
 * http://scottjehl.github.io/picturefill/
*/

import picturefill from '../lib/_picturefill.min';

picturefill();
